import { Action } from '@ngrx/store';
import { Definition } from 'app/core/store/definitions/definition.interface';

export const SET_ACTIVE_CUSTOMER = 'active-customer:SET_ACTIVE_CUSTOMER';

export class SetActiveCustomerAction implements Action {
  readonly type = SET_ACTIVE_CUSTOMER;
  logPayload = true;

  constructor(readonly payload: Definition) {}
}


export type Actions = SetActiveCustomerAction;
